import { useFetcher } from 'react-router';

import type { OrderNotification } from '~/types/order';

import { useRootLoader } from './useUser';

function isOrderNotifications(notifications: any): notifications is OrderNotification[] {
  return (
    notifications &&
    typeof notifications === 'object' &&
    Array.isArray(notifications) &&
    notifications.every((n) => n.content)
  );
}

export function useOrderNotifications(): OrderNotification[] {
  const data = useRootLoader();
  if (!data || !isOrderNotifications(data.notifications)) {
    return [];
  }
  return data.notifications;
}

export function useOrderNotificationUnreadCount(): number {
  const data = useRootLoader();
  if (!data) {
    return 0;
  }
  return data.unreadNotificationCount;
}

export function useOrderNotificationTotalCount(): number {
  const data = useRootLoader();
  if (!data) {
    return 0;
  }
  return data.notificationTotalCount;
}

export function useMarkOrderNotificationsRead() {
  const fetcher = useFetcher();

  return (notificationIds: string[]) => {
    const formData = new FormData();
    notificationIds.forEach((id) => formData.append('notificationIds', id));

    fetcher.submit(formData, {
      method: 'POST',
      action: '/read-notification',
      preventScrollReset: true,
    });
  };
}
